import React from 'react';
import { SensorDeviceTooltip } from '@/features/sensorMaintenanceLens';
import type { MapHoverObject } from '../hooks/useMapHover';

interface MapTooltipContentProps {
	infra: MapHoverObject;
}

const MapTooltipContent: React.FC<MapTooltipContentProps> = ({ infra }) => {
	if (infra?._tooltipType === 'sensor') {
		return <SensorDeviceTooltip device={infra} />;
	}

	if (infra?._tooltipType === 'dma') {
		return (
			<div className="px-3 py-2 min-w-[120px] font-sans bg-white rounded-xl shadow-lg">
				<span className="text-sm font-semibold text-[#232B36]">
					DMA Name: {infra.dmaName ?? infra.dmaId ?? 'N/A'}
				</span>
			</div>
		);
	}

	const usage = infra?.mainMeasurementTarget?.usage ?? 0;
	const expired = infra?.mainMeasurementTarget?.expired;
	const statusText = expired ? 'No Data Available' : 'Online';
	const statusColorClass = expired ? 'bg-[#F46A6A]' : 'bg-[#34C38F]';
	const progressColorClass = usage > 100 ? 'bg-[#F46A6A]' : 'bg-[#078CB3]';
	const progressWidth = Math.min(usage, 100);
	const measurementTargetName = infra?.mainMeasurementTarget?.measurementTargetName || 'N/A';

	return (
		<div className="px-3.5 py-4 min-w-[200px] font-sans bg-white rounded-xl shadow-lg">
			<div className="flex items-center gap-2 mb-1">
				<span className="font-semibold text-lg text-[#232B36]">
					{infra.measurementInfraestructureName}
				</span>
			</div>
			<div className="text-xs font-bold text-[#232B36] text-center mb-1">
				{infra.infrastructureTypeName}
			</div>
			<div className={expired ? '' : 'mb-2'}>
				<div className="flex items-center justify-center gap-2 px-5 h-8 bg-white rounded-full border border-[#C4CCD5] shadow-sm w-full">
					<div className={`w-4 h-4 rounded-full ${statusColorClass}`}></div>
					<span className="text-sm text-[#74788D] font-medium">
						{statusText}
					</span>
				</div>
			</div>
			{!expired && (
				<>
					<div className="bg-white rounded h-6 overflow-hidden mb-1 border border-[#023E65]">
						<div
							className={`h-full transition-all duration-300 ${progressColorClass}`}
							style={{ width: `${progressWidth}%` }}
						></div>
					</div>
					<div className="text-sm font-bold text-[#1C2A4E]">
						{measurementTargetName} | {usage}% Capacity
					</div>
				</>
			)}
		</div>
	);
};

export default MapTooltipContent;
